module.exports = __webpack_public_path__ + "static/img/6.160d8c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/6.png
// module id = Ci1b
// module chunks = 0